var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loadingNormal)?_c('div',{class:_vm.classArr},[_vm._m(0)]):_vm._e(),(!_vm.loadingNormal)?_c('div',[_vm._m(1)]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loadingLogoCoonfia"}},[_c('div',{staticClass:"loading c1"}),_c('div',{staticClass:"loading c2"})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loadingLogoCoonfia"}},[_c('div',{staticClass:"loading c1"}),_c('div',{staticClass:"loading c2"})])
}]

export { render, staticRenderFns }